export default "__VITE_ASSET__DcfAMd2f__"